
import {
  defineComponent, computed, ref, reactive, onMounted
} from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import SubscriptionManageIcon from '@/components/svg/subscriptions-manage.svg?inline';
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import SubscriptionList from '@/views/subscriptions/components/SubscriptionList.vue';
import Chevron from '@/components/svg-components/Chevron.vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import useUser from '@/mixins/useUser';
import IconLightBulb from '@/components/svg/profile-lightbulb.svg?inline';
import BCXFilterTabs from '@/components/filter/BCXFilterTabs.vue';
import SubscriptionManagerTag from '@/views/subscriptions/components/subscription-manager/SubscriptionManagerTag.vue';
import EditIcon from '@/components/molecules/EditIcon.vue';

export default defineComponent({
  name: 'SubscriptionManager',
  components: {
    BCXHelpTextTriggerIcon,
    BCXBreadcrumbs,
    Chevron,
    BCXInfoCollapsible,
    SubscriptionList,
    SubscriptionManageIcon,
    IconLightBulb,
    BCXFilterTabs,
    SubscriptionManagerTag,
    EditIcon
  },
  setup() {
    const isInlineHelpOpened = ref(false);
    const store = useStore();
    const { tUserFallback: t, isFreelancer } = useUser('self');

    const isMobileLayout = computed(() => store.getters['page/isMobileLayout']);
    const isSubscriptionsLoading = computed(() => store.state.subscriptions.loadingSubscriptions);
    const breadcrumbItems = computed(() => {
      const breadcrumbArray: any = [
        {
          text: 'Home',
          to: {
            name: 'home',
          },
        },
        {
          text: t('subscriptions.title'),
          to: {
            name: 'subscriptions',
          },
        },
        {
          text: t('subscriptions.manage'),
          to: {
            name: 'manageSubscriptions',
          },
        },
      ];
      if (isMobileLayout.value) {
        breadcrumbArray[0] = { text: 'ByteCookie' };
      }
      return breadcrumbArray;
    });

    const filters = reactive(t('subscriptions.filters') as any);
    const activeFilter = ref('ALL');

    function isFilterActive(key: any): boolean {
      return key === activeFilter.value;
    }

    function setFilter(key: string) {
      activeFilter.value = key;
    }

    const feedLink = computed(() => ({
      name: 'subscriptions',
    }));

    const toggleInlineHelp = () => {
      isInlineHelpOpened.value = !isInlineHelpOpened.value;
    };

    function refreshSubscriptions() {
      store.dispatch('subscriptions/fetchSubscriptions');
    }

    function onCheckHeuristics(value: boolean) {
      store.dispatch('subscriptions/updateAllTagSettings', { heuristic: value });
    }

    onMounted(() => {
      store.dispatch('subscriptions/fetchAllTagSettings');
    });

    return {
      isMobileLayout,
      breadcrumbItems,
      isInlineHelpOpened,
      feedLink,
      t,
      isSubscriptionsLoading,
      filters,
      isFilterActive,
      setFilter,
      activeFilter,
      toggleInlineHelp,
      refreshSubscriptions,
      onCheckHeuristics,
      isFreelancer,
    };
  },
});
